import { takeLatest } from 'redux-saga/effects';
import { favoritesForDoctorWorkerSaga } from './favoritesForDoctorWorkerSaga';
import { FETCH_FAVORITES_FOR_DOCTOR_REQUEST } from '../../redux/modules/favoriteAccounts/favoritesForDoctor-actions';

export function* favoriteForDoctorWatcherSaga() {
    yield takeLatest(FETCH_FAVORITES_FOR_DOCTOR_REQUEST, favoritesForDoctorWorkerSaga);
}

export default favoriteForDoctorWatcherSaga;
